import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import useGetInfoFromQuery, { USER_INFO_KEY } from '@/hooks/useGetInfoFromQuery'
import useUpdateBaseInfo from '@/hooks/useUpdateBaseInfo'
import { DashboardSamlBackend } from '@/types/schemas/dashboardSingleSignOn.schemas'
import { waitAMoment } from './common/tools'
import { omit } from 'lodash'
import { ElConfigProvider } from 'element-plus'
import { useElementLocal } from '@/hooks/useElementLocal'
import i18nInstance from './i18n'
import { setFavicon, setPageTitle } from '@/store/tool'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const lang = computed(() => {
  return store.state.lang
})
const theme = computed(() => {
  return store.state.theme
})
const syncOsTheme = computed(() => {
  return store.state.syncOsTheme
})

const updateThemeState = (theme: string) => {
  store.dispatch('UPDATE_SETTINGS', {
    lang: lang.value,
    theme,
    syncOsTheme: syncOsTheme.value,
  })
}
const { locale: elementLocale } = useElementLocal()

// Sync OS theme
const hadleSyncOSTheme = () => {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    updateThemeState('dark')
  } else {
    updateThemeState('light')
  }
}
// Watch the OS theme change
const setWatchOSTheme = () => {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
    const osTheme = event.matches ? 'dark' : 'light'
    if (store.state.syncOsTheme && osTheme !== theme.value) {
      updateThemeState(osTheme)
    }
  })
}
const setTheme = () => {
  const currentTheme = theme.value
  document.documentElement.setAttribute('data-theme', currentTheme)
}
const setLang = () => {
  const lang = theme.value
  // i18nInstance.global.locale = lang
  document.documentElement.setAttribute('lang', lang)
}
const setSystemInfo = () => {
  const systemInfo = store.getters['systemStore/systemInfo']
  systemInfo.logoIcon && setFavicon(systemInfo.logoIcon)
  systemInfo.loginTitle && setPageTitle(systemInfo.loginTitle)
}
setSystemInfo()
setLang()
setTheme()
setWatchOSTheme()
if (syncOsTheme.value) {
  hadleSyncOSTheme()
}

const router = useRouter()
const route = useRoute()
const { getUserInfoFromQuery } = useGetInfoFromQuery()
const { updateBaseInfo } = useUpdateBaseInfo()
const handleQuery = async () => {
  const info = getUserInfoFromQuery()
  if (info) {
    location.replace(location.origin + location.pathname + location.hash)
    /**
     * Currently, if info is from location.search, it's using single sign-on;
     * if it's from route.query, it's from ECP (i.e., no backend)
     */
    const backend = location.search ? DashboardSamlBackend.saml : undefined
    updateBaseInfo(info.username, info, backend)
    // if in login page, redirect to overview page
    if (/login/i.test(location.hash.split('?')[0])) {
      router.push({ name: 'overview' })
    }
    await waitAMoment()
    // remove login meta from query for safe
    if (route.query) {
      const newQuery = omit(route.query, USER_INFO_KEY)
      router.replace({ ...route, query: newQuery })
    }
  }
}

handleQuery()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(elementLocale) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})